var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BindingEngine } from "aurelia-binding";
import { autoinject, transient } from "aurelia-dependency-injection";
import { EventAggregator } from "aurelia-event-aggregator";
import { I18N } from "aurelia-i18n";
import { Router } from "aurelia-router";
import { validateTrigger, ValidationControllerFactory, ValidationRules } from "aurelia-validation";
import { RouterConstants } from "../../../../configuration/router.constants";
import { EntityTypes } from "../../../../models/basics/basics.models";
import { StepEnum } from "../../../../models/modules/lotteryplatofrm.models";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
import { ApiSettingClientService } from "../../../../services/modules/api-setting-client.service";
import { BaseEntity } from "../../../pages/modules/base-entity";
import { AppSettingBasicMeta } from "./steps/api-settings-basic-meta";
import { DialogClientService } from '../../../../services/basics/dialog-client.service';
var ManageApiSettings = /** @class */ (function (_super) {
    __extends(ManageApiSettings, _super);
    function ManageApiSettings(apiSettingClientService, router, bindingEngine, i18N, notificationService, eventAggregator, appSettingBasicMeta, validationControllerFactory, dialogClientService) {
        var _this = _super.call(this, router, bindingEngine, i18N, notificationService, eventAggregator) || this;
        _this.apiSettingClientService = apiSettingClientService;
        _this.router = router;
        _this.bindingEngine = bindingEngine;
        _this.i18N = i18N;
        _this.notificationService = notificationService;
        _this.eventAggregator = eventAggregator;
        _this.appSettingBasicMeta = appSettingBasicMeta;
        _this.dialogClientService = dialogClientService;
        _this.controller = null;
        _this.controller = validationControllerFactory.createForCurrentScope();
        _this.controller.validateTrigger = validateTrigger.changeOrBlur;
        return _this;
    }
    ManageApiSettings.prototype.initValidations = function (newItem) {
        this.rules = ValidationRules
            .ensure(function (x) { return x.name; }).required().withMessage("Api setting name is required.")
            .ensure(function (x) { return x.apiKey; }).required().withMessage("Api key is required")
            .ensure(function (x) { return x.userId; }).required().withMessage("Client User Id is required")
            .on(newItem)
            .rules;
    };
    ManageApiSettings.prototype.initializeItemOverride = function (newItem) {
        this.initValidations(newItem);
    };
    ManageApiSettings.prototype.initializeItemOverrideForUpdate = function (newItem) {
        this.initValidations(newItem);
    };
    ManageApiSettings.prototype.getListRoute = function () {
        return RouterConstants.RouteNames.ListApiSettings;
    };
    ManageApiSettings.prototype.getSteps = function () {
        return [{
                title: "App Setting Basic Meta",
                step: StepEnum.AppSettingsBasicMeta,
                vm: this.appSettingBasicMeta,
                show: true,
                view: '../../app/admin/manage-api-settings/steps/api-settings-basic-meta.html'
            }];
    };
    ManageApiSettings.prototype.attached = function () {
        this.initValidations(this.item);
    };
    ManageApiSettings.prototype.getItem = function (id) {
        return this.apiSettingClientService.getApiSetting(id);
    };
    ManageApiSettings.prototype.getItemId = function () {
        return this.item.apiSettingId;
    };
    ManageApiSettings.prototype.beforeSave = function (skipValidation, resolve) {
        var _this = this;
        this.controller.validate({ object: this.item, rules: this.rules }).then(function (result) {
            resolve(result.valid, _this.controller.errors.map(function (x) { return x.message; }).join("\n"));
        });
    };
    ManageApiSettings.prototype.deleteApiSetting = function () {
        var _this = this;
        this.apiSettingClientService.delete(this.item.apiSettingId).then(function (x) {
            _this.notificationService.show("Deleted", "Api setting deleted successfully", NotificationType.Success);
            _this.router.navigateToRoute(_this.getListRoute());
        });
    };
    ManageApiSettings.prototype.saveItem = function (id, changes) {
        var apiSetting = { changes: changes, id: id };
        return this.apiSettingClientService.saveApiSetting(apiSetting);
    };
    ManageApiSettings.prototype.getUpdateRoute = function () {
        return RouterConstants.RouteNames.ManageApiSettings;
    };
    ManageApiSettings.prototype.getEntityType = function () {
        return EntityTypes.ApiSettings;
    };
    ManageApiSettings.prototype.initializeItemForCreate = function () {
        return {
            apiSettingId: null,
            apiKey: null,
            name: null,
            apiSettingPermissions: [],
            userId: null,
            isActive: false
        };
    };
    ManageApiSettings.prototype.handleUpdateCompleted = function (response, isNew) {
        _super.prototype.handleUpdateCompleted.call(this, response, isNew);
    };
    ManageApiSettings = __decorate([
        autoinject(),
        transient(),
        __metadata("design:paramtypes", [ApiSettingClientService,
            Router,
            BindingEngine,
            I18N,
            NotificationClientService,
            EventAggregator,
            AppSettingBasicMeta,
            ValidationControllerFactory,
            DialogClientService])
    ], ManageApiSettings);
    return ManageApiSettings;
}(BaseEntity));
export { ManageApiSettings };
